import { useContext, useEffect } from 'react';

import { ScrollLockContext } from './scrollLockContext';

export const useScrollLock = (isOpen: boolean, id: string, isEnabled = true): void => {
  const { lockScroll, unlockScroll } = useContext(ScrollLockContext);

  useEffect(() => {
    if (isEnabled) {
      if (isOpen) {
        lockScroll(id);
      } else {
        unlockScroll(id);
      }
    }

    return () => {
      unlockScroll(id);
    };
  }, [isEnabled, isOpen, id, lockScroll, unlockScroll]);
};
